export default {
	'home-page': '',
	'products-page': '',
	'news-page': '',
	'services-page': '',
	'albums-page': '',
	'about-us-page': '',
	'seo-fields': ''
}